<template>
  <div class="rootContainer" ref="rootcontainer">
    <div class="chartdiv" ref="chartdiv"></div>
    <div id="legend" ref="legend"></div>
  </div>
</template>

<script>
import Vue from "vue";
import VueTypes from "vue-types";

import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";
import am4themes_animated from "@amcharts/amcharts4/themes/animated";

am4core.useTheme(am4themes_animated);

export default Vue.component("VPieChart", {
  props: {
    mail_statistics: VueTypes.arrayOf(
      VueTypes.shape({
        key: VueTypes.any,
        label: VueTypes.string,
        value: VueTypes.number,
        color: VueTypes.string
      })
    )
  },

  methods: {
    hoverSlice(item) {
      item.isHover = true;
    },

    blurSlice(item) {
      item.isHover = false;
    }
  },

  mounted() {
    let $vm = this;

    am4core.options.commercialLicense = true;

    var container = am4core.create(this.$refs.chartdiv, am4core.Container);
    container.width = am4core.percent(100);
    container.height = am4core.percent(100);

    let chart = container.createChild(am4charts.PieChart);
    chart.width = am4core.percent(100);
    chart.layout = "horizontal";

    //when chart is render
    // chart.events.on("ready", function() {});

    // Add and configure Series
    var pieSeries = chart.series.push(new am4charts.PieSeries());
    pieSeries.dataFields.value = "value";
    pieSeries.dataFields.category = "label";

    // Let's cut a hole in our Pie chart the size of 30% the radius

    // Put a thick white border around each Slice
    pieSeries.slices.template.stroke = am4core.color("#fff");
    pieSeries.slices.template.strokeWidth = 0;
    pieSeries.slices.template.strokeOpacity = 1;
    pieSeries.slices.template.propertyFields.fill = "color";
    // change the cursor on hover to make it apparent the object can be interacted with
    pieSeries.slices.template.cursorOverStyle = [
      {
        property: "cursor",
        value: "pointer"
      }
    ];

    pieSeries.alignLabels = false;
    pieSeries.labels.template.radius = am4core.percent(-30);
    pieSeries.labels.template.padding(0, 0, 0, 0);
    pieSeries.labels.template.text = "{value.percent.formatNumber('#.0')}%";
    pieSeries.labels.template.fontSize = 12;
    pieSeries.labels.template.fill = am4core.color("white");

    pieSeries.ticks.template.disabled = true;

    //hide small labels
    // pieSeries.ticks.template.adapter.add("hidden", hideSmall);
    pieSeries.labels.template.adapter.add("hidden", hideSmall);
    function hideSmall(hidden, target) {
      return target.dataItem.values.value.percent < 5;
    }

    // Add label
    chart.innerRadius = 85;
    var labelTitle = chart.seriesContainer.createChild(am4core.Label);
    labelTitle.adapter.add("text", function(text, target) {
      return (
        "[fill: #5757F5; bold font-size:24px ]" +
        pieSeries.dataItem.values.value.sum
      );
    });
    labelTitle.horizontalCenter = "middle";
    labelTitle.verticalCenter = "bottom";

    var label = chart.seriesContainer.createChild(am4core.Label);
    label.text = "Total";
    label.horizontalCenter = "middle";
    label.verticalCenter = "top";
    label.fontSize = 20;

    // Create a base filter effect (as if it's not there) for the hover to return to
    var shadow = pieSeries.slices.template.filters.push(
      new am4core.DropShadowFilter()
    );
    shadow.opacity = 0;

    // Create hover state
    var hoverState = pieSeries.slices.template.states.getKey("hover"); // normally we have to create the hover state, in this case it already exists

    // Slightly shift the shadow and make it more prominent on hover
    var hoverShadow = hoverState.filters.push(new am4core.DropShadowFilter());
    hoverShadow.opacity = 0.7;
    hoverShadow.blur = 5;

    // Create custom legend
    chart.events.on("ready", function(event) {
      // populate our custom legend when chart renders
      chart.customLegend = document.getElementById("legend");
      pieSeries.dataItems.each(function(row, i) {
        const color = chart.colors.getIndex(i);
        const percent = Math.round(row.values.value.percent * 100) / 100;
        const value = row.value;
        const identifier = `legend-item-${i}`;

        legend.innerHTML += `<div class="legend-item" id="${identifier}"
                 >
                    <div class="legend-value-percents">${percent}%</div>
                    <div class="legend-value">${value} total</div>
                    <div class="legend-label" style="color: ${$vm.mail_statistics[i].color};">${row.category}</div>
                </div>`;
      });

      document.querySelectorAll(".legend-item").forEach((item, i) => {
        const pieItem = pieSeries.slices.getIndex(i);
        const dataItem = pieSeries.dataItems.getIndex(i);

        if (item.children[1].innerText === "0 total") {
          item.classList.add("empty");
        }

        item.addEventListener("mouseover", () => {
          $vm.hoverSlice(pieItem, item);
        });

        item.addEventListener("mouseout", () => {
          $vm.blurSlice(pieItem, item);
        });
      });
    });

    chart.data = this.mail_statistics;
  } // end am4core.ready()
});
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
.rootContainer {
  display: flex;
  align-items: center;
}

.chartdiv {
  min-width: 450px;
  height: 400px;
}

#legend {
  width: 100%;
  height: fit-content;
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
  align-items: center;
}

#legend .legend-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 110px;
  width: 160px;
  cursor: pointer;
  margin: 10px;
  padding: 5px;

  &.empty {
    opacity: 0.25;
    pointer-events: none;
  }

  &.onClick {
    box-shadow: 2px 2px 25px rgba(0, 0, 0, 0.15);
  }

  .legend-value-percents {
    font-size: 26px;
    line-height: 1.4;
    color: $primary-color;
    margin-bottom: 5px;
  }

  .legend-value {
    font-size: 14px;
    line-height: 1.2;
    color: $secondary-text-color;
    font-family: Lato-Light, Arial, Helvetica Neue, Helvetica, sans-serif;
    margin-bottom: 26px;
  }

  .legend-label {
    font-size: 14px;
  }
}

/*Media*/

@media screen and (max-width: 991px) {
  .rootContainer {
    flex-direction: column;
  }
  .chartdiv {
    width: 100%;
  }

  #legend .legend-item {
    margin: 10px 5px;
  }
}
</style>
